export const EXILED_BRAND = Object.freeze({
  id: "landing-primary",
  name: "EXILED",
  subline: "SYSTEMS",
  logoPath: "/assets/brand/exiled-systems-logo-primary.png",
  logoAlt: "Exiled Systems dimensional E.S. cube logo",
  canonicalSource: "apps/exiled-public-portal/assets/social_world_hub/exiled-systems-logo-primary.png",
  canonicalSha256: "0905676D56EC3B0B7350D221FF2424210C57958CCB342BFDB1E5C0A620DE7499",
});

export function brandLinkMarkup({ className = "brand", logoClassName = "brand-mark" } = {}) {
  return `
    <a class="${className}" href="/" aria-label="Exiled Systems home" data-brand-id="${EXILED_BRAND.id}">
      <img class="${logoClassName}" src="${EXILED_BRAND.logoPath}"
        alt="${EXILED_BRAND.logoAlt}" width="1254" height="1254"
        loading="eager" decoding="sync" fetchpriority="high" draggable="false"
        data-brand-logo="${EXILED_BRAND.id}" data-brand-sha256="${EXILED_BRAND.canonicalSha256}">
      <span><strong>${EXILED_BRAND.name}</strong><small>${EXILED_BRAND.subline}</small></span>
    </a>`;
}
